import { createElement } from 'react';

import type { QueryClient } from '@tanstack/react-query';
import type { ProviderContext, SnackbarKey } from 'notistack';

import { Button } from '@mui/material';

import { type LensUndoEntry, lensChangeFailure, toggleLensUndo } from './useLensChange';

type Snackbar = Pick<ProviderContext, 'enqueueSnackbar' | 'closeSnackbar'>;

export function lensUndoAction(client: QueryClient, key: ReadonlyArray<string>, snackbar: Snackbar) {
  const entry = client.getQueryData<LensUndoEntry>(key);
  if (!entry) return undefined;
  return (snackbarKey: SnackbarKey) =>
    createElement(
      Button,
      {
        color: 'inherit',
        size: 'small',
        onClick: () => {
          snackbar.closeSnackbar(snackbarKey);
          void toggleLensUndoWithToast(client, key, snackbar);
        },
      },
      entry.undone ? 'Redo' : 'Undo',
    );
}

export async function toggleLensUndoWithToast(client: QueryClient, key: ReadonlyArray<string>, snackbar: Snackbar) {
  try {
    await toggleLensUndo(client, key);
  } catch (error) {
    snackbar.enqueueSnackbar(lensChangeFailure(error), { variant: 'warning' });
  }
}
